import { useEffect, useState, useMemo } from 'react';
import CommonService from '../services/common.service';

/**
 * Loads `master_facility_sub_type` for the selected asset category (`facility_type_id`).
 * GET /master/facility-sub-types/:facilityTypeId
 */
export function useMasterFacilitySubTypes(facilityTypeId) {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const parsedId = useMemo(() => {
    if (facilityTypeId == null || String(facilityTypeId).trim() === '') return null;
    const n = parseInt(String(facilityTypeId), 10);
    return Number.isNaN(n) ? null : n;
  }, [facilityTypeId]);

  useEffect(() => {
    let cancelled = false;
    if (parsedId == null) {
      setList([]);
      setLoading(false);
      setError(null);
      return;
    }
    async function load() {
      setLoading(true);
      setError(null);
      try {
        const response = await CommonService.get(`/master/facility-sub-types/${parsedId}`);
        if (cancelled) return;
        const raw = response?.data;
        setList(Array.isArray(raw) ? raw : []);
      } catch (e) {
        if (!cancelled) {
          setError(e);
          setList([]);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    }
    load();
    return () => {
      cancelled = true;
    };
  }, [parsedId]);

  return { list, loading, error, facilityTypeId: parsedId };
}
